import axios from "axios";
import { getQueryString } from "./util/tools";

import * as tools from "./util/tools";
import Vue from "vue";
import ECharts from "vue-echarts";
import App from "./App";

import router from "./router";
import store from "./vuex/store";
import moment from "moment";
// 全局组件
import citmsUI from "citms-ui-package";
import sliderLeft from "./common/sliderLeft/sliderLeft";
import cSearch from "./common/formSelectItem/formSelectItem";
import crypto from 'crypto'
import VirtualCollection from 'vue-virtual-collection'

Vue.use(VirtualCollection)

import * as filters from './util/filter.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false;
Vue.prototype.crypto = crypto;
Vue.prototype.tools = tools;

Vue.use(citmsUI);
Vue.component("slider-left", sliderLeft);
Vue.component("c-search", cSearch);
window.Token = getQueryString("Token") || window.localStorage.getItem("TOKEN");
let skinLocal = window.localStorage.getItem("themePage");
skinLocal = (skinLocal!='null'?skinLocal:'')
window.Skin = getQueryString("Skin") || skinLocal || 'lightBlue';
if (getQueryString('PlatformClientPort')) localStorage.setItem('PlatformClientPort', getQueryString('PlatformClientPort'));
// 首页菜单默认排序
window.sortMode = "default";
if (Token) {
  window.localStorage.setItem("TOKEN", Token);
  window.localStorage.setItem("themePage", Skin);
}
// 解决登录超时问题
let startTime = "";
let interval = 0;
window.addEventListener("click", function(e) {
  let token = window.localStorage.getItem("TOKEN");
  if (startTime) {
    interval =
      parseInt(`${moment().format("YYYYMMDDHHmmss")}`) - parseInt(startTime);
    startTime = `${moment().format("YYYYMMDDHHmmss")}`;
  } else {
    startTime = `${moment().format("YYYYMMDDHHmmss")}`;
  }
  if (interval > 10) {
    axios({
      url: window.baseURL + "/smw/UAC/DelayTimeout",
      method: "post",
      headers: {
        Authorization: "Basic" + token
      }
    }).then(res => {});
  }
});

// 获取首页菜单排序类型
let params = {};
params.type = "sortMode";
$.ajax({
  url: window.baseURL + "/common/UserConfig/GetSingleConfigInfo",
  type: "get",
  async: false,
  contentType: "application/json",
  data: params,
  beforeSend: function(XMLHttpRequest) {
    XMLHttpRequest.setRequestHeader("Authorization", "Basic " + window.Token);
  },
  success: function(res) {
    if (res.code == 0) {
      if (res.result && res.result.profile) {
        window.sortMode = res.result.profile;
      }
    }
  }
});

// 获取水印配置
let getWaterMask = function(userInfo){
  axios({
    url: `${baseURL}/common/ConfigOptions/GetConfigByCategoryNo?categoryNo=smw/WatermarkConfig`,
    method: "get",
    headers: {
      Authorization: "Basic " + Token
    }
  }).then(res => {
    if (res.data.code == 0){
      let waterMaskConfig = res.data.result||{enableWatermark:false}
      let {loginInfo} = userInfo
      // 打水印
      if(waterMaskConfig.enableWatermark){
        addWaterMark(userInfo.userName, userInfo.departmentName,loginInfo.clientIP,waterMaskConfig)
      }
    }
  })
}
//获取用户信息异步处理
let initData = new Promise(resolve => {
  axios({
    url: baseURL + "/smw/UAC/GetUserInfo",
    method: "get",
    headers: {
      Authorization: "Basic " + Token
    }
  }).then(res => {
    if (res.data.code == 0) {
      let result = res.data.result
      getWaterMask(result)
      resolve(res.data);
    } else {
      var local = window.location.href;
      if (
        local.indexOf("/Common/GoLogin") == -1 ||
        local.indexOf("login.html") == -1
      ) {
        if (window.top == self) {
          window.location.href =
            baseURL + "/Common/GoLogin?returnUri=" + local;
        } else {
          layer.msg("登录超时！", { icon: 2, time: 3000, zIndex: 10000 });
          setTimeout(() => {
            
            let map = {
              "?": "@",
              "&": "$",
            }
            let reStr = '(' + Object.keys(map).map(it => '\\' + it).join('|') + ')'
            let re = new RegExp(reStr, 'g')
            let href = window.location.href
            href = href.replace(re, it => map[it])

            window.location.href = baseURL +"/Common/GoLogin?returnUri=" + href;
            // window.location.href = baseURL +"/Common/GoLogin?returnUri=" + window.location.origin +"/#/";
          }, 3000);
        }
      }
    }
  })
  .catch(err => {
    console.log(err);
  });
});

// 获取首页地址配置
let homePageUrl = new Promise(resolve => {
  axios({
    url: `${baseURL}/common/ConfigOptions/GetConfigByCategoryNo?categoryNo=smw/LoginSecurity`,
    method: "get",
    headers: {
      Authorization: "Basic " + Token
    }
  }).then(res => {
    if (res.data.code == 0){
      let result = res.data.result
      let homePageUrl = result&&result.homePageUrl?result.homePageUrl:''
      resolve(homePageUrl)
    }else {
      resolve()
    }
  }).catch(err => {
    resolve()
  });
});
// 获取菜单页布局模式
let menuMode = new Promise(resolve => {
  let menuMode = localStorage.getItem('menuMode')
  resolve({menuMode: menuMode||"top"})
});

if (window.signalR) {
  //开启了signalR推送功能，获取signalR地址
  axios({
    url: window.baseURL + "/common/GetSignalRNode",
    method: "get",
    headers: {
      Authorization: "Basic " + window.Token
    }
  })
    .then(res => {
      if (res.data.code === 0) {
        window.signalRURL = res.data.result;
      } else {
        console.error("获取消息中心节点信息异常：" + res.data.message);
      }
    })
    .catch(err => {
      console.log(err);
    });
}

// 接受其他微服务发送的消息
window.addEventListener('message', function(messageEvent) {
  var data = messageEvent.data; 
  // 登录
  if(data.loginStatus==2){
    window.openLoginModal(data.currentRoute)
  }
  if (data.TOKEN) {
    window.Token = data.TOKEN
    localStorage.setItem('TOKEN', data.TOKEN)
    let msg={"TOKEN":data.TOKEN}
    let  iframes=document.getElementsByTagName("iframe")
    if(iframes&&iframes.length>0){
      for(let i=0;i<iframes.length;i++){
        iframes[i].contentWindow.postMessage(msg, '*')
      }
    }
  }
  // 专项违法
  if(data.controlId){
    let  iframes=document.getElementsByTagName("iframe")
    if(iframes&&iframes.length>0){
      for(let i=0;i<iframes.length;i++){
        iframes[i].contentWindow.postMessage(data, '*')
      }
    }
  }
}, false);

Promise.all([initData,homePageUrl,menuMode]).then(res=>{
  store.dispatch("setUserInfo", res[0].result);
  window.homePageUrl = res[1]
  store.dispatch("setDesktopConfig",res[2]||{menuMode: "top"})
  window.VueModel = new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>",
    watch: {
      $route(to, from) {
        if (from.name) window.location.reload();
        let head = document.getElementsByTagName("HEAD").item(0);
        if (to.path == "/map") {
          var style = document.createElement("link");
          style.id = "mainBlackStyle";
          style.href = "/static/skin/black-min.css";
          style.rel = "stylesheet";
          style.type = "text/css";
          head.appendChild(style);
        } else {
          if (document.querySelector("#mainBlackStyle"))
            head.removeChild(document.querySelector("#mainBlackStyle"));
        }
      }
    }
  });
})


let mainStyle = 'lightBlue'
if (Skin) { mainStyle = Skin }
mainStyle = 'lightBlue'
// 动态插入主体样式表
let head = document.getElementsByTagName('HEAD').item(0)
var style = document.createElement('link')
style.href = '/static/skin/' + mainStyle + '-min.css'
style.rel = 'stylesheet'
style.type = 'text/css'
head.appendChild(style)



// WEBPACK FOOTER //
// ./src/main.js